import React from 'react';
import PropTypes from 'prop-types';
import glamorous, { withTheme } from 'glamorous';
import { ChromePicker } from 'react-color';

import { media, palette } from '../../styles';
import createPalette from '../../styles/createPalette';

import Caption from '../typography/Caption';

import StickersheetRow from './StickersheetRow';

const SwatchContainerDiv = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  justifyContent: 'center',
});

const TILE_WIDTH = 46;

const Swatches = glamorous.div({
  display: 'flex',
  flexDirection: 'row',
  flexWrap: 'wrap',
  width: (TILE_WIDTH * 3),
  margin: 4,

  [media('sm')]: {
    margin: 8,
  }
});

const SwatchTile = glamorous.div(props => ({
  position: 'relative',
  display: 'flex',
  width: props.hasLabel ? (TILE_WIDTH * 3) : TILE_WIDTH,
  height: props.hasLabel ? (TILE_WIDTH * 3) : TILE_WIDTH,
  backgroundColor: props.color || '#ccc',
  margin: 0,
  padding: props.hasLabel ? 8 : 4,
  fontSize: props.hasLabel ? 16 : 12,
  lineHeight: props.hasLabel ? '16px' : '12px',
  alignItems: 'flex-end',
  justifyContent: 'flex-end',

  '&:hover': {
    cursor: props.hasLabel ? 'pointer' : 'default',
  },
}));

const SwatchText = glamorous.span(props => ({
  color: '#ffffff',
  textShadow: '0px 1px 1px rgba(0,0,0,0.54)',
  textTransform: 'uppercase',
}));

class Swatch extends React.PureComponent {
  static propTypes = {
    type: PropTypes.string.isRequired,
    variant: PropTypes.string.isRequired,
    label: PropTypes.string,
  };

  state = {
    color: this.props.color || palette[this.props.type][this.props.variant],
    isViewingPicker: false,
  };

  componentWillReceiveProps(nextProps) {
    if (nextProps.color) {
      if (nextProps.color !== this.state.color || nextProps.color !== this.props.color) {
        this.setState({ color: nextProps.color });
      }
    }
  }

  handleShowPicker = (e) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({
      isViewingPicker: true,
    });
  };

  handleClosePicker = (e) => {
    e.stopPropagation();
    e.preventDefault();

    this.setState({
      isViewingPicker: false,
    });
  };

  handleChangeComplete = (color) => {
    this.setState({
      color: color.hex,
    });

    this.props.onChangeColor(color);
  };

  render() {
    const { variant, label } = this.props;

    return (
      <SwatchTile
        color={this.state.color}
        hasLabel={!!label}
        onClick={this.handleShowPicker}
      >
        <SwatchText variant={variant}>
          <Caption>{label || variant}</Caption>
        </SwatchText>

        {!!label && this.state.isViewingPicker && (
          <div
            style={{
              position: 'absolute',
              zIndex: 2,
              bottom: '75%',
            }}
          >
            <div
              onClick={this.handleClosePicker}
              style={{ position: 'fixed', top: 0, left: 0, bottom: 0, right: 0 }}
            />
            <ChromePicker
              color={this.state.color}
              onChangeComplete={this.handleChangeComplete}
            />
          </div>
        )}
      </SwatchTile>
    );
  }
}

class SwatchContainer extends React.PureComponent {
  handleChangeColor = (color) => {
    const palette = createPalette(color.hex);
    this.props.onChangeTheme({[this.props.type]: palette});
  };

  render() {
    const {
      type,
    } = this.props;

    return (
      <Swatches>
        <Swatch
          type={type}
          variant="base"
          label={type}
          onChangeColor={this.handleChangeColor}
          color={this.props.palette.base}
        />
        <Swatch color={this.props.palette['100']} type={type} variant="100" />
        <Swatch color={this.props.palette['200']} type={type} variant="200" />
        <Swatch color={this.props.palette['300']} type={type} variant="300" />
        <Swatch color={this.props.palette['400']} type={type} variant="400" />
        <Swatch color={this.props.palette['500']} type={type} variant="500" />
        <Swatch color={this.props.palette['600']} type={type} variant="600" />
        <Swatch color={this.props.palette['700']} type={type} variant="700" />
        <Swatch color={this.props.palette['800']} type={type} variant="800" />
        <Swatch color={this.props.palette['900']} type={type} variant="900" />
        <Swatch color={this.props.palette['A100']} type={type} variant="A100" />
        <Swatch color={this.props.palette['A200']} type={type} variant="A200" />
        <Swatch color={this.props.palette['A400']} type={type} variant="A400" />
      </Swatches>
    );
  }
}

const paletteTypes = ['default', 'primary', 'secondary', 'accent', 'info', 'success', 'danger', 'warning'];

class SwatchesContainer extends React.Component {
  render() {
    return (
      <StickersheetRow title="Swatches">
        <SwatchContainerDiv>
          {paletteTypes.map(type => (
            <SwatchContainer
              key={type}
              type={type}
              palette={this.props.theme[type]}
              onChangeTheme={this.props.onChangeTheme}
            />
          ))}
        </SwatchContainerDiv>
      </StickersheetRow>
    );
  }
}

export default withTheme(SwatchesContainer);


// WEBPACK FOOTER //
// ./src/components/demo/Swatches.js